$(document).ready(function(){
  // hero banner icon slider
  $('.block__hero-banner-slider').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    // autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          autoplay: false,
        }
      }
    ]
  });
  // text animation slider
  $(".block__text-animation-slider-wrapper,.block__logo-animation-slider-wrapper").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    swipe: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    pauseOnFocus: false,
    pauseOnHover: false
  });
});

$('.block__video-with-product-wrapper').slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: false,
  responsive: [
    {
      breakpoint: 1221,
      settings: {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 990,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 750,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelector('.announcement-bar__message') != null) {
    var custom_date = document.querySelector('.announcement-bar__message').getAttribute('data-date');
    if (custom_date !== null && custom_date !== ''){
    var countDownDate = new Date(custom_date).getTime();

    // Run myfunc every second
    var myfunc = setInterval(function() {

    var now = new Date().getTime();
    var timeleft = countDownDate - now;
        
    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
        if (days < 10) {days = "0"+days}
        if (hours < 10) {hours = "0"+hours}
        if (minutes < 10) {minutes = "0"+minutes}
        if (seconds < 10) {seconds = "0"+seconds}
    document.getElementById("days").innerHTML = days
    document.getElementById("hours").innerHTML = hours
    document.getElementById("mins").innerHTML = minutes
    document.getElementById("secs").innerHTML = seconds
        
    if (timeleft < 0) {
        clearInterval(myfunc);
        document.querySelectorAll(".block__timer--announcement,.block__timer--dots").forEach((timer_announcement) => {
            timer_announcement.style.display = "none";
        });
        document.getElementById("days").innerHTML = ""
        document.getElementById("hours").innerHTML = "" 
        document.getElementById("mins").innerHTML = ""
        document.getElementById("secs").innerHTML = ""
        document.getElementById("end").innerHTML = "TIME UP!!";
    }
    }, 1000);
    };
};
    document.querySelectorAll('[id^="Details-"].mega-menu').forEach((hover_menu) => {
      hover_menu.addEventListener("mouseenter", MouseEnter_event);
      hover_menu.addEventListener("mouseleave", MouseLeave_event);
    });
    document.querySelectorAll('.mega-menu .block__menu-overlay').forEach((hover_overlay) => {
      hover_overlay.addEventListener("mouseenter", Menu_close_event);
    });

    function  MouseEnter_event(event) {
      var __this = event.currentTarget;
      __this.querySelector('summary').setAttribute('aria-expanded', true);
      __this.setAttribute('open','open');
      document.body.classList.add('menu-overflow-hidden');
    }
    function  MouseLeave_event(event) {
      var __this = event.currentTarget;
      __this.querySelector('summary').setAttribute('aria-expanded', false);
      __this.removeAttribute('open','open');
      document.body.classList.remove('menu-overflow-hidden');
    }
    function  Menu_close_event(event) {
      var __this = event.currentTarget;
      __this.closest('details.mega-menu').querySelector('summary').setAttribute('aria-expanded', false);
      __this.closest('details.mega-menu').removeAttribute('open','open');
      document.body.classList.remove('menu-overflow-hidden');
    }

    document.querySelectorAll('.mega-menu__link--level-2').forEach((hover_submenu) => {
      hover_submenu.addEventListener("mouseenter", MouseEnter_submenuEvent);
    });

    function MouseEnter_submenuEvent(event) {
      var __this = event.currentTarget;
      var menu_name = __this.getAttribute('data-title');
      var remove_class = __this.closest('.mega-menu__content').querySelectorAll('.mega-menu__link.nav-active');
      remove_class.forEach(el=>el.classList.remove('nav-active'));
      __this.classList.add('nav-active');

      var remove_class2 = __this.closest('.mega-menu__content').querySelectorAll('.block__mega-child-links-with-banner');
      remove_class2.forEach(el=>el.classList.remove('active'));

      __this.closest('.mega-menu__content').querySelector(`[data-submenu-title="${menu_name}"]`).classList.add('active');
    }

    document.querySelectorAll('.block__variant-image').forEach((variant_select) => {
      variant_select.addEventListener("click", OnImageClickVariantChange);
    });



    document.querySelectorAll('.article-shareitem .icon-copy-link').forEach((copy_content) => {
      copy_content.addEventListener("click", copyContent);
    });

    function copyContent(event) {
      var __this = event.currentTarget;
      var text = __this.getAttribute('data-url');
      navigator.clipboard.writeText(text);
    }




    $(document).click(function (e) {
      var container = $(".block__sticky-join-bar");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.block__sticky-join-bar').removeClass('active')
        }
    });


    if(window.screen.availWidth < 1221 ){
      document.querySelectorAll('.footer-block--menu h4.footer-block__heading').forEach((footer_menu) => {
        footer_menu.addEventListener("click", OnClickMenuOpen);
      });

      function OnClickMenuOpen(event){
        var __this = event.currentTarget;
        if(__this.closest('.footer-block--menu').classList.contains('open')){
          __this.closest('.footer-block--menu').classList.remove('open');
        } else {
          var remove_class = __this.closest('.footer__blocks-wrapper').querySelectorAll('.footer-block--menu');
        remove_class.forEach(el=>el.classList.remove('open'));
        __this.closest('.footer-block--menu').classList.add('open');
        }
      }
    }
});

// sign up page checkbox checked
$(document).on('click','.block__register-page-policy-check',function(){
  var checkbox = $(this).closest('.block__register-page-policy-check').find('#policy-check');
  var team_select = $('#selet_fav_team').val();
  if( team_select == 'Select Your Favorite Sport.') {
    team_select = '';
  }
  if($(checkbox).is(':checked')){
    $('#customer_tags').val('Subscribed_phone,'+team_select);
  }else{
    $('#customer_tags').val(team_select);
  }
});
$(document).on('change','#selet_fav_team',function(){
  var checkbox = $('#policy-check:checked').length;
  var team_select = $(this).val();
  if( team_select == 'Select Your Favorite Sport.') {
    team_select = '';
  }
  if(checkbox > 0){
    $('#customer_tags').val('Subscribed_phone,'+team_select);
  }else{
    $('#customer_tags').val(team_select);
  }
});


// =============blog-page.js==============
document.querySelectorAll('.block__blog-filter-inner-header p').forEach((DrawerFilter) => {
  DrawerFilter.addEventListener("click", OnClickDrawerFilterOpen);
});

function OnClickDrawerFilterOpen(event){
  var __this = event.currentTarget;
  if(__this.closest('.block__blog-filter-drawer').classList.contains('open')){
    __this.closest('.block__blog-filter-drawer').classList.remove('open');
  } else {
    __this.closest('.block__blog-filter-drawer').classList.add('open');
  }
}
document.querySelectorAll('.blog__filter-close-icon,.block__blog-overlay').forEach((DrawerFilterclose) => {
  DrawerFilterclose.addEventListener("click", OnClickDrawerFilterClose);
});

function OnClickDrawerFilterClose(event){
  var __this = event.currentTarget;
    __this.closest('.block__blog-filter-drawer').classList.remove('open');
}



// start account page js
document.querySelectorAll('.block_customers-order-info-top-right').forEach((openOrderTab) => {
  openOrderTab.addEventListener("click", OnClickOpenOrderTab);
});

function OnClickOpenOrderTab(event){
  var __this = event.currentTarget;
    __this.closest('.block_customers-order-info').querySelector('.block_customers-order-info-bottom').classList.toggle('active');
}

if(window.innerWidth < 1101) {
  document.querySelectorAll('.block__account-page-tab-title').forEach((openAccountTab) => {
    openAccountTab.addEventListener("click", OnClickOpenAccountTitleTab);
  });

  function OnClickOpenAccountTitleTab(event){
    var __this = event.currentTarget;
      __this.closest('.block__customer-account-titles').querySelector('.block__customer-account-menu').classList.toggle('active');
  }
}

document.querySelectorAll('.block__account-page-tab-title').forEach((openAccountTab) => {
  openAccountTab.addEventListener("click", OnClickOpenAccountTitleTab);
});

function OnClickOpenAccountTitleTab(event){
  var __this = event.currentTarget;
    __this.closest('.block__customer-account-titles').querySelector('.block__customer-account-menu').classList.toggle('active');
}

document.querySelectorAll('.block__viewmore-addresses-btn a').forEach((view_address) => {
  view_address.addEventListener("click", OnClickViewmoreAdresses);
});

function OnClickViewmoreAdresses(event){
  var __this = event.currentTarget;
  if(__this.innerText == 'View More'){
    __this.innerText = 'View Less'
  } else {
    __this.innerText = 'View More'
  }
    __this.closest('.block_address-list-main').querySelector('.block_address-list.all-addresses').classList.toggle('view-all');
}

$(document).on("click" , ".add-address-button" , function(){
  $(this).parents(".block__customer-account-detailed").find("#AddAddress").toggleClass("hidden");
  $(".block_address_form").addClass("hidden");
})

$(document).on("click" , ".edit-address-button", function(){
  let formId = $(this).attr("data-form-id");
  $(this).parents(".block__customer-account-detailed").find("#AddAddress").addClass("hidden");
  $('.block_address_form').addClass("hidden");
  $(this).parents(".block__customer-account-detailed").find(`#${formId}`).toggleClass("hidden");
});

// end account page js

// for search filter
$(document).on('keyup','#search-blogs',function(e){
  if($(this).val().length > 0 || !$('.blog__search .blog--search-clear').is(':visible') ){
    $('.blog__search .blog--search-clear').css('display','block')
  }
})
$(document).on('keydown','.blog__search',function(e){
  if( e.keyCode == 13 ){
    blog_predictive_search(e);
  }
});
$(document).on('click','.blog__search button',function(e){
  blog_predictive_search(e);
});
$(document).on('click','.blog__search .blog--search-clear',function(e){
  $(".blog__search").find('#search-blogs').val('');
  $.ajax({
    url: $(location).attr("href"),
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      var article_grid = $(responseHTML).find('.blog-articles').html()
      if(article_grid.length > 0) {
      $('.blog-articles').html(article_grid);
      } else {
        $('.blog-articles').html('<p class="medium_body">Articles Not Found !!!</p>');
      }
      $('.main-blog .pagination-wrapper').removeClass('hidden');
    },
  });
  $(this).css('display','none');
});
function blog_predictive_search(e){
  e.preventDefault();
  var targetForm = $(".blog__search");
  var input_val = $(targetForm).find('#search-blogs').val();
  var urlWithParams = "/search?view=search-2&type=article&q="+ input_val;
    $.ajax({
      url: urlWithParams,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        var article_grid = $(responseHTML).find('.blog-articles').html()
        if(article_grid.length > 0) {
        $('.blog-articles').html(article_grid);
        } else {
          $('.blog-articles').html('<p class="medium_body">Articles Not Found !!!</p>');
        }
        $('.main-blog .pagination-wrapper').addClass('hidden');
      },
    });
  }


// Product page slider

$('.product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.thumbnail-list',
  responsive: [
    {
        breakpoint: 990,
        settings: {
          adaptiveHeight: true,
        }
    }
  ]
});
$('.thumbnail-list').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  vertical:true,
  asNavFor: '.product__media-list',
  dots: false,
  focusOnSelect: true,
  verticalSwiping:true,
  responsive: [
  {
      breakpoint: 990,
      settings: {
        vertical: false,
        verticalSwiping:false,
      }
  },
  {
    breakpoint: 580,
    settings: {
      slidesToShow: 5,
      vertical: false,
      verticalSwiping:false,
    }
  },
  {
    breakpoint: 421,
    settings: {
      slidesToShow: 3,
      vertical: false,
      verticalSwiping:false,
    }
  }
  ]
});



document.querySelectorAll('.block__size-guide-popup').forEach((openpopup) => {
  openpopup.addEventListener("click", OnClickOpenPopupsize);
});

function OnClickOpenPopupsize(event){
  var popupclass = document.querySelector('.block__size-guide-popup-image');
  popupclass.classList.add('open');
  document.body.classList.add('overflow-hidden');
}
document.querySelectorAll('.close-size-popup-icon,.size-popup-overlay').forEach((closepopup) => {
  closepopup.addEventListener("click", OnClickPopupClose);
});

function OnClickPopupClose(event){
  var popupclass = document.querySelector('.block__size-guide-popup-image');
  popupclass.classList.remove('open');
  document.body.classList.remove('overflow-hidden');
}


// =============policy-page.js============

$(document).on("click" , ".block__section-policy-pages-dropdown-title" ,function(){
  $(this).toggleClass("active")
  $(this).parents(".block__section-policy-pages-dropdown-toggle").find(".block__section-policy-pages-dropdown").slideToggle()
})
$(".block__section-policy-pages-content-info p , .block__section-policy-pages-content-info span").filter(function(){
    return $.trim(this.innerHTML) === "&nbsp;"
}).remove();

$(".article-template__content p , .article-template__content span , .article-template__content b").filter(function(){
    return $.trim(this.innerHTML) === "&nbsp;"
}).remove();

$(window).on("load" , function(){
  $("body").addClass("active")
     $(".block__section-policy-pages-links-inner p a").each(function(){
     let page_url = $(this).parents(".block__section-policy-pages-links").attr("data-href")
     $(`.block__section-policy-pages-links-inner p a[href="${page_url}"]`).addClass("active")
  });
})
// ==============form.js==========

$(document).on('change','.block_field_input-select .field__input' ,function() {
   if($(this).find(":selected").val() == "Other" || $(this).find(":selected").val() == "other"){
     $(".block_other-textarea").removeClass("hidden");
     $(".block_other-textarea").find('textarea').attr("required", "true");
   }else{
     $(".block_other-textarea").addClass("hidden");
     $(".block_other-textarea").find('textarea').removeAttr("required", "true");
   }
});


mathHeight('block-start-learining-content-video','block-start-learining-content-video-inner','block-start-learining-top-content-subtitle', 3 , 2 , 1 );
mathHeight('block-start-learining-content-video','block-start-learining-content-video-inner','block-start-learining-top-content-title', 3 , 2, 1 );

// =============collecion-js==============

if(window.innerWidth > 750) {
  document.querySelectorAll('.block__collection-filter-title a').forEach((openCategory) => {
    openCategory.addEventListener("click", OnClickOpenCategoryMenuTab);
  });

  function OnClickOpenCategoryMenuTab(event){
    event.preventDefault();
    var __this = event.currentTarget;
    __this.closest('.block__collection-category-menulist').classList.toggle('active');
  }
}

$(document).on("click" ,".block__collection-sort-filter-option input" , function(){
  let value = $(this).val();
  $("#SortBy").val(value).trigger('change');
  $("#SortBy").val(value).prop("selected" , "selected")
  document.querySelector('#SortBy').dispatchEvent(new Event('change', { 'bubbles': true }))
})
$(document).ready(function(){
  setTimeout(function(){
    var value_sortby = $('#SortBy').find('option:selected').val();
    $('.block__collection-sort-filter-option-inner').find('input[value="'+ value_sortby +'"]').prop( "checked", true );
  },100)
})

  if($(window).width() > 749){
    $(".facets-container").css("margin-top" , "-"+($(".block__collection-sort-filter-with-title").height() + 40)+"px")
  }

$(document).on("click" , ".block_mobile-filter-grid-main" , function(){
  $(".mobile_faccts_click").trigger("click")
})

// smooth animation
$("a").on('click', function(event) {
  if (this.hash !== "") {
    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 500, function(){
      window.location.hash = hash;
    });
  }
});


// search orders
// $(document).on("input change",".block__account-tabs-orders-search-input",function(){
//   var filter = $(this).val().toUpperCase();
//   $(".block_customers-order-info").each(function() {
//       var a = $(this).find(".block_order-name span").first();
//       var txtValue = a.text() || a.attr("innerText");
//       if (txtValue.toUpperCase().indexOf(filter) > -1) {
//           $(this).css("display", "");
//       } else {
//           $(this).css("display", "none");
//       }
//   });
// });
function you_may_like_arrow_drawer() {
  $("#CartDrawer .primary-title").prepend("<span class='prev-arrows'></span>")
  $("#CartDrawer .primary-title").append("<span class='next-arrows'></span>")
}

$(document).on("click", ".rebuy-button,  .rebuy-button span , .rebuy-product-actions", function() {
  var $this = $(this); // Declare $this here
  var interval = setInterval(doStuff, 100);
  function doStuff() {
    if (!$this.parents(".rebuy-widget-container").find(".rebuy-button").hasClass("working")) {
      clearInterval(interval);
      setTimeout(function () {
        updateCart();
      }, 100);
    }
  }
});

function updateCart() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
      const cartid = 'CartDrawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('#CartDrawer');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(document.querySelector('.block__free--product-wrapper') != null){
        add_free_product();
      }
      if(document.querySelector('#switch-rounded') != null ){
        shipping_protection_product();
      }
      update_cart_item_count();
      $(".cart-count-bubble").trigger("click");
      let handles = setInterval(you_may_like_arrow_drawer, 1000);
      setTimeout(function(){
        clearInterval(handles);
      }, 10000);
  });
}

function shipping_protection_product(){
  if(document.querySelector('#switch-rounded') != null) {
    product_protection_B2B();
  }
}

function add_free_product(event){
  fetch('/cart.json')
  .then((res) => {
    return res.json();
  }).then((data) => {
    var var_id = document.querySelector('.block__free--product-wrapper').getAttribute('data-id');
    if(document.querySelector('.block_drawer-progress') != null){
      var free_gift_price = document.querySelector('.block_drawer-progress').getAttribute('data_add_freegift_price');
      if(data.total_price >= free_gift_price) {
        if(document.querySelector('.free-product-added') == null ){
          var formData = {
            id: var_id,
            quantity: 1,
          };
          this.product_Add_function(formData);
        }
      }else{
        if(document.querySelector('.free-product-added') != null ){
          document.querySelector('.free-product-remove').dispatchEvent(new Event('click', { 'bubbles': true }));
        }
      }
    }
  });
}
function product_Add_function(formData){
  fetch('/cart/add.js', {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.drawer__header','.block__protection-product-price'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        if(document.querySelector('.protection-pro-hide') != null ){
          document.querySelector('#switch-rounded').setAttribute("checked", "true");
        }
      })
    }).catch(function(err) {
      console.error(err)
    });
}

$(document).on("click" , "#CartDrawer .prev-arrows" ,function(){
  $("#CartDrawer .splide__arrow--prev").trigger("click");
})
$(document).on("click" , "#CartDrawer .next-arrows" ,function(){
  $("#CartDrawer .splide__arrow--next").trigger("click");
})

// Custom-apparel page
$(document).on("click",".block__apparel-tabbing-title-text a",function(e){
  e.preventDefault();
  var nav_value = $(this).attr('data-href');
  $('.block__apparel-tabbing-title-text').removeClass('nav-active');
  $('.block__apparel-tabbing-images-main').removeClass('active');
  $(this).parent('.block__apparel-tabbing-title-text').addClass('nav-active');
  $(nav_value).closest('.block__apparel-tabbing-images-main').addClass('active');
  $('.block__apparel-tabbing-images').slick('refresh')
});

// sticky add to cart button on product page
function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
$(document).ready(function(){
  if($('.block__sticky-atc-main-button').length > 0){
    $(window).scroll(function(elem){
      if(window.innerWidth > 750) {
        var scroll_view = 500;
      }else {
        var scroll_view = 800;
      }
      if($(window).scrollTop() > scroll_view){
        if (isScrolledIntoView($('product-form')) || isScrolledIntoView($('.footer__content-top')) || isScrolledIntoView($('.footer__content-middle'))) {
            $('.block__sticky-atc-main-button').removeClass('active');
          } else {
            $('.block__sticky-atc-main-button').addClass('active');
          }
      }else {
        $('.block__sticky-atc-main-button').removeClass('active');
      }
    });
  }
});

$(document).on('change','.block__sticky-button-variants-dropdown .select__select',function(){
  var val = $(this).find('option:selected').val();
  $('fieldset').find('input[value="'+ val +'"]').trigger('click')
})

$(document).on('click','#block__pdp-sticky-atc-button',function(){
  $('.product-form__submit').trigger('click');
});